<template>

    <!-- Begin PDFMessage form: -->

    <v-card class="send-pdf-message-form assessment-share-page-btn-action popup-scoring-assessment"
            v-if="isVisible">

        <v-card-text>
            <v-flex xs12 sm12 class="no-padding-left no-padding-bottom">

                <span class="font-weight-bold">{{text('pdf.message.recipient.title')}}</span>
                <br />
                <span>{{text('pdf.message.recipient.subtitle')}}</span>
                <v-text-field
                    v-model="pdfMessageRecipient"
                    :placeholder="text('pdf.message.recipient.placeholder')"
                    @change="validateRecipient"
                    solo
                ></v-text-field>

                <p v-if="!isPdfMessageRecipientValid" class="phone-error">{{pdfMessageRecipientErrorText}}</p>
                <p v-if="apiError" class="phone-error">{{apiError}}</p>

                <br />

                <v-checkbox
                    v-model="userAgreement"
                    :rules="userAgreementCheckboxRule"
                    :label="text('pdf.message.agreeToService')"
                    hide-details
                    color="primary"
                    class="pdf-message-user-agreement-checkbox">
                </v-checkbox>

            </v-flex>

            <!-- PDF template selector: -->
            <v-flex v-if="getPdfTemplateList.length > 1" xs12 sm12 class="no-padding-left">
                <div class="pdf-template-list">
                    <span class="font-weight-bold">{{text('api.share.page.translatePdf.selectTemplate')}}</span>

                    <pdf-template-selector-radio-group
                        :selected-template="selectedPdfTemplate"
                        @onChangeSelectedTemplate="selectedPdfTemplate = $event.selectedPdfTemplate"
                    ></pdf-template-selector-radio-group>
                </div>
            </v-flex>

            <!-- PDF language selector: -->
            <v-flex v-if="getPdfTranslateLanguageList.length > 1" xs12 sm12 class="no-padding-left">
                <div class="pdf-template-list">
                    <span class="font-weight-bold">{{text('api.share.page.translatePdf.selectLanguage')}}</span>
                    <pdf-translate-language-selector-radio-group
                        :selected-language="selectedPdfLanguage"
                        :language-list="getPdfTranslateLanguageList"
                        @onChangeSelectedPdfLanguage="selectedPdfLanguage = $event.selectedPdfLanguage"
                    ></pdf-translate-language-selector-radio-group>
                </div>
            </v-flex>

        </v-card-text>


        <v-card-actions>

            <v-btn class="color-on-primary-text" v-if="!isSent" @click="handleClickSendBtn()" :disabled="!isFormValid || loading" color="primary">{{text('api.button.send')}}</v-btn>
            <v-btn class="color-on-primary-text" v-if="!isSent" @click="handleClickSendAndCloseBtn()" :loading="loading" :disabled="!isFormValid || loading" color="primary">{{text('api.button.send.and.close')}}</v-btn>

            <p v-if="isSent" class="successfulSent">{{ text('api.scoring.send.popup.text') }}</p>

        </v-card-actions>

    </v-card>
    <!-- End PDFMessage form -->


</template>

<script>

import { mapGetters } from 'vuex';
import Vue from "vue";
import PdfTemplateSelectorRadioGroup
    from "../../../../common/components/shared/assessment-share/PdfTemplateSelectorRadioGroup";
import PdfTranslateLanguageSelectorRadioGroup
    from "../../../../common/components/shared/assessment-share/PdfTranslateLanguageSelectorRadioGroup";

export default {
    name: 'TranslatePdfForm',
    components: {
        PdfTemplateSelectorRadioGroup,
        PdfTranslateLanguageSelectorRadioGroup
    },

    props: ['isVisible', 'loading', 'apiError'],

    data() {
        return {
            pdfMessageRecipient: '', // Can be filled with a phone number, an email address or a Threema ID.
            pdfMessageRecipientErrorText: "",
            userAgreement: "",
            userAgreementCheckboxRule: [
                (value) => (value == true)
            ],
            selectedPdfTemplate: '',
            selectedPdfLanguage: 'or',
            isSent: false,
            checkBoxPlugin: Vue.CheckBox.checkBoxSvg,
        };
    },

    computed: {
        ...mapGetters({
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray'
        }),

        getPdfTemplateList() {
            return this.getAppPropertyValueArray('PDF_TEMPLATE');
        },

        getPdfTranslateLanguageList() {
            let threemaLanguages = this.getAppPropertyValueArray('THREEMA_TRANSLATE_LANGUAGES');

            // if there aren't any THREEMA_TRANSLATE_LANGUAGES, we do not need to add the button for Original Language,
            // in all other cases we need it.
            if(threemaLanguages.length > 0){
                threemaLanguages.unshift("or");
            }

            return threemaLanguages;
        },

        isPdfMessageRecipientValid() {
            return (this.pdfMessageRecipientErrorText.length > 0) ? false : true;
        },

        isFormValid() {
            return (
                this.selectedPdfTemplate !== ""
                && this.pdfMessageRecipient !== ""
                && this.isPdfMessageRecipientValid === true
                && this.userAgreement == true
            ) ? true : false;
        }
    },

    beforeMount() {
        if (this.getPdfTemplateList.length === 1) {
            // If there is only one PDF template, consider it already selected (so it will be automatically selected
            // and no radio buttons for template selection will be displayed).
            this.selectedPdfTemplate = this.getPdfTemplateList[0];
        }
        if (this.getPdfTranslateLanguageList.length === 1) {
            // If there is only one PDF language, consider it already selected (so it will be automatically selected
            // and no radio buttons for language selection will be displayed).
            this.selectedPdfLanguage = this.getPdfTranslateLanguageList[0];
        }
    },

    watch: {

        userAgreement(newValue, oldValue) {
            if (newValue === true) {
                let that = this;
                setTimeout(function () {
                    let userAgreementCheckbox = document.getElementsByClassName('pdf-message-user-agreement-checkbox');
                    for (let i = 0; i < userAgreementCheckbox.length; i++) {
                        let iconCheckBox = userAgreementCheckbox[i].getElementsByClassName('icon--checkbox');

                        for (let j = 0; j < iconCheckBox.length; j++) {
                            iconCheckBox[j].innerHTML = that.checkBoxPlugin();
                        }
                    }
                }, 10);
            }
        }
    },

    methods: {

        validateRecipient(value) {
            this.$emit("onChangeRecipient", value); // This will help to reset the error messages that came from a previous API request.

            let errorMsg = "";

            if (value.length < 1) {
                errorMsg = this.text("api.error.field.required");
            }

            const phoneRegex = /^((\+|00)\d{2}|0)(( )?\d){9,12}$/;
            const mailRegex = /^(([a-zA-Z0-9_\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df\-.]+)@((\[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df\-]+\.)+))([a-zA-Z\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]{2,15}|[0-9]{1,3})(]?)(\s*\040\s*|\s*$))*$/;
            const threemaIDRegex= /^[A-Z0-9]{8}$/;

            if(!phoneRegex.test(value) && !mailRegex.test(value) && !threemaIDRegex.test(value)){
                errorMsg = this.text("pdf.message.recipient.invalid")
                    + " (" + this.text('pdf.message.recipient.placeholder') + ")";
            }

            this.pdfMessageRecipientErrorText = errorMsg;
        },

        handleClickSendBtn() {
            this.$emit("onClickSendBtn", {
                recipient: this.pdfMessageRecipient,
                userAgrees: this.userAgreement,
                template: this.selectedPdfTemplate,
                translationLanguage: this.selectedPdfLanguage
            });
        },

        handleClickSendAndCloseBtn() {
            this.$emit("onClickSendAndCloseBtn", {
                recipient: this.pdfMessageRecipient,
                userAgrees: this.userAgreement,
                template: this.selectedPdfTemplate,
                translationLanguage: this.selectedPdfLanguage
            });
        },
    }

}



</script>

<style lang="scss" scoped>
    .send-pdf-message-form {
        margin-bottom: 60px;
    }

    .assessment-share-page .send-pdf-message-form .phone-error {
        padding-top: 4px;
        color: #ff0000 !important;
    }
</style>



// WEBPACK FOOTER //
// src/professional/components/assessment-share/forms/SendPdfMessageForm.vue